import axios from "axios";

const whitelabelApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    Accept: "application/json",
    "X-Origin": "WEB",
    "X-Platform": "web",
  },
});

export default whitelabelApi;
